import type { SettingsStore } from './interfaces'

export const actions = {
  setLoading (this: SettingsStore, payload: SettingsStore['loading']): void {
    this.loading = payload
  },
  setSettings (this: SettingsStore, payload: SettingsStore['settings']): void {
    this.settings = payload
  },
  setExperiments (this: SettingsStore, payload: SettingsStore['experiments']): void {
    this.experiments = payload
  },
  setConfigVaultUrl (this: SettingsStore, payload: SettingsStore['configVaultUrl']): void {
    this.configVaultUrl = payload
  },
}
